<template>
  <v-app>
    <acttiv v-if='hotel' />
    <dviewcontent v-else-if='id' />
    <dviewcontent-show v-else-if='show' />
    <dview v-else-if='dview || cmDviewcontentEvents'/>
    <cm-dviewcontent v-else-if='cmDviewcontent' />
    <!--cm-dviewcontent-events v-else-if='cmDviewcontentEvents' /-->
  </v-app>
</template>

<script>
import axios from 'axios'
import utils from '@/services/utils'
import Acttiv from '@/components/Acttiv'
import Dviewcontent from '@/components/Dviewcontent'
import DviewcontentShow from '@/components/DviewcontentShow'
import cmDviewcontent from '@/components/cmDviewcontent'
//import cmDviewcontentEvents from '@/components/cmDviewcontentEvents'
import Dview from '@/components/Dview'
// ?zoom=80&hotel=34&addDays=1&c1=tomato&c2=blue&c5=red&folder=wantudu
export default {
  name: 'App',

  components: {
    Acttiv,
    Dviewcontent,
    DviewcontentShow,
    Dview,
    cmDviewcontent,
    //cmDviewcontentEvents,
  },

  data: () => ({
  }),
  computed: {
    cmDviewcontentEvents () {
      return utils.getParameterByName('cmdviewcontentevents')
    },
    cmDviewcontent () {
      return utils.getParameterByName('cmdviewcontent')
    },
    dview () {
      return utils.getParameterByName('dview')
    },
    hotel () {
      return utils.getParameterByName('hotel')
    },
    show () {
      return utils.getParameterByName('showID')
    },
    id () {
      return utils.getParameterByName('id')
    },
    previewCSS () {
      return utils.getParameterByName('previewCSS')
    },
  },
  mounted () {
    this.handleGetCSS()
  },
  methods: {
    async handleGetCSS () {
      const id = this.cmDviewcontent || this.dview || this.hotel || this.show || this.id
      const urlCSS = `https://cm-player-api.dtouchwebapp.com/v1/public/css/${id}/activity-player/${this.previewCSS ? 'preview' : ''}`
      await new Promise((resolve) => axios.get(urlCSS, { headers: { 'Content-Type': 'application/json',} })
        .then(response => {
          const css = response.data ? response.data.map(item => JSON.parse(item)).shift() : null
          if (css) {
            let style = document.createElement('style')
            style.appendChild(document.createTextNode(css.split('\\n').join('').split('\\t').join('')))
            document.head.appendChild(style)
          }
          resolve()
        }))
    },
  },
}
</script>

<style>
#app {
  background: none;
}
html {
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
html::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
}
</style>

